// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../node_modules/rescript/lib/es6/js_dict.js";

function allocation_radius_encode(v) {
  return Js_dict.fromArray([
              [
                "auto",
                Decco.intToJson(v.auto)
              ],
              [
                "manual",
                Decco.intToJson(v.manual)
              ],
              [
                "radius_delta",
                Decco.optionToJson(Decco.intToJson, v.radius_delta)
              ]
            ]);
}

function dry_run_encode(v) {
  return Js_dict.fromArray([
              [
                "threshold",
                Decco.intToJson(v.threshold)
              ],
              [
                "ratio",
                Decco.floatToJson(v.ratio)
              ],
              [
                "radius_delta",
                Decco.optionToJson(Decco.floatToJson, v.radius_delta)
              ]
            ]);
}

function max_dry_run_encode(v) {
  return Js_dict.fromArray([
              [
                "manual",
                Decco.intToJson(v.manual)
              ],
              [
                "auto",
                Decco.intToJson(v.auto)
              ],
              [
                "radius_delta",
                Decco.optionToJson(Decco.intToJson, v.radius_delta)
              ]
            ]);
}

function filters_encode(v) {
  return Js_dict.fromArray([
              [
                "allocation_radius",
                allocation_radius_encode(v.allocation_radius)
              ],
              [
                "dry_run",
                dry_run_encode(v.dry_run)
              ],
              [
                "maps_distance",
                max_dry_run_encode(v.maps_distance)
              ]
            ]);
}

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "geo_region_id",
                Decco.intToJson(v.geo_region_id)
              ],
              [
                "vehicle_id",
                Decco.intToJson(v.vehicle_id)
              ],
              [
                "campaign_name",
                Decco.stringToJson(v.campaign_name)
              ],
              [
                "start_date_time",
                Decco.floatToJson(v.start_date_time)
              ],
              [
                "filters",
                filters_encode(v.filters)
              ]
            ]);
}

export {
  allocation_radius_encode ,
  dry_run_encode ,
  max_dry_run_encode ,
  filters_encode ,
  t_encode ,
  
}
/* No side effect */
